"use client";

import { Quote } from "lucide-react";

interface TestimonialProps {
  quoteTitle: string;
  body: string;
  author: string;
  role: string;
  index?: number;
  variant?: "dark" | "light";
}

export const Testimonial = ({
  quoteTitle,
  body,
  author,
  role,
  index = 1,
  variant = "dark",
}: TestimonialProps) => {
  const isDark = variant === "dark";

  const wrapStyle = isDark
    ? { background: "#1A2E4A" }
    : { background: "#F7F5F0", border: "1px solid #E2DDD6" };

  const quoteColor = isDark ? "#C9A84C" : "#1A2E4A";
  const bodyColor = isDark ? "rgba(247,245,240,0.75)" : "#6B6860";
  const authorColor = isDark ? "#F7F5F0" : "#1C1C1A";
  const roleColor = isDark ? "rgba(247,245,240,0.5)" : "#6B6860";

  const cleanBody = (body || "")
    .replace(/^["""']+|["""']+$/g, "")
    .trim();
  const cleanTitle = (quoteTitle || "")
    .replace(/^["""']+|["""']+$/g, "")
    .trim();

  return (
    <figure
      data-testid={`testimonial-${index}`}
      className="reveal relative overflow-hidden rounded-sm p-8 md:p-12"
      style={wrapStyle}
    >
      <Quote
        size={160}
        strokeWidth={1}
        aria-hidden
        className="absolute -top-6 -left-6 pointer-events-none"
        style={{
          color: isDark ? "#C9A84C" : "#1A2E4A",
          opacity: isDark ? 0.1 : 0.08,
          transform: "scaleX(-1)",
        }}
      />

      <div className="relative z-10 max-w-2xl">
        <p
          className="font-display italic text-xl md:text-2xl leading-relaxed mb-6"
          style={{ color: quoteColor }}
        >
          &ldquo;{cleanTitle}&rdquo;
        </p>
        <p
          className="font-body text-base leading-relaxed mb-6"
          style={{ color: bodyColor }}
        >
          {cleanBody}
        </p>
        <figcaption>
          <span
            className="font-body font-semibold text-sm"
            style={{ color: authorColor }}
          >
            {author}
          </span>
          <span
            className="font-body text-sm ml-2"
            style={{ color: roleColor }}
          >
            {role}
          </span>
        </figcaption>
      </div>
    </figure>
  );
};
